import React from 'react';
import { useNavigate } from 'react-router-dom';

function PantryPal() {
  const navigate = useNavigate();

  // Apply theme synchronously to prevent flash
  const savedTheme = localStorage.getItem('theme');
  if (savedTheme) {
    const isDarkMode = document.documentElement.classList.contains('dark-mode');
    if (savedTheme === 'dark' && !isDarkMode) {
      document.documentElement.classList.add('dark-mode');
    } else if (savedTheme === 'light' && isDarkMode) {
      document.documentElement.classList.remove('dark-mode');
    }
  }

  const toggleTheme = () => {
    const isDarkMode = document.documentElement.classList.toggle('dark-mode');
    localStorage.setItem('theme', isDarkMode ? 'dark' : 'light');
  };

  return (
    <div className="App">
      <nav className="main-nav">
        <div className="nav-left">
          <div className="headshot-container">
            <img
              src="/static/images/profile-picture.png"
              alt="Profile"
              className="headshot"
              onClick={() => navigate('/')}
            />
          </div>
          <div className="nav-logo">Robert Study</div>
        </div>
        <div className="nav-links">
          <a onClick={() => navigate('/')}>Back to Home</a>
        </div>
      </nav>

      <section className="hero-section">
            <div className="hero-content" style={{
            display: 'flex',
            gap: '2rem',
            alignItems: 'flex-start',
            maxWidth: '1200px',
            margin: '0 auto',
            padding: '0 2rem',
            }}>
            <div className="hero-text-content" style={{ flex: '1' }}>
                <h1>Pantry<span className="highlight">Pal</span></h1>
                <p style={{
                    fontSize: '1.1rem',
                    color: 'var(--text-color)',
                    marginBottom: '2rem',
                    lineHeight: 1.6,
                    fontFamily: 'Arial, sans-serif'
                }}>
                    A comprehensive pantry management app with real-time features, API integrations, and a robust backend system.
                </p>
                <button
                  className="resume-button"
                  onClick={() => window.open('https://github.com/robertstudy/Pantry-Pal', '_blank')}
                  style={{
                    padding: '1rem 2.5rem',
                    fontSize: '1.2rem',
                    cursor: 'pointer',
                    textDecoration: 'none',
                    border: 'none',
                    background: 'var(--secondary-color)',
                    color: 'var(--bg-color)',
                    borderRadius: '10px',
                    fontWeight: '600',
                    boxShadow: '0 4px 12px var(--nav-shadow)',
                    transition: 'all 0.2s ease',
                    minWidth: '200px',
                    marginRight: '1rem',
                  }}
                >
                  View GitHub Repo
                </button>
                <button
                  className="resume-button"
                  onClick={() => window.open('https://www.youtube.com/watch?v=XYmEzghNRDA', '_blank')}
                  style={{
                    padding: '1rem 2.5rem',
                    fontSize: '1.2rem',
                    cursor: 'pointer',
                    textDecoration: 'none',
                    border: 'none',
                    background: 'var(--primary-color)',
                    color: 'var(--bg-color)',
                    borderRadius: '10px',
                    fontWeight: '600',
                    boxShadow: '0 4px 12px var(--nav-shadow)',
                    transition: 'all 0.2s ease',
                    minWidth: '200px',
                  }}
                >
                  View Live Demo
                </button>
            </div>
            <div style={{
                flex: '1',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                maxWidth: '600px',
                minWidth: '220px',
            }}>
                <img
                src="/static/images/pantrypal.png"
                alt="AWS Logo"
                style={{
                    width: '100%',
                    height: 'auto',
                    maxWidth: '600px',
                    borderRadius: '16px',
                    boxShadow: '0 4px 24px rgba(0,0,0,0.13)',
                    objectFit: 'contain',
                    background: 'var(--bg-color)'
                }}
                />
            </div>
            </div>
        </section>

      <main style={{ maxWidth: '1300px', margin: '0 auto', padding: '0rem 1.5rem 0 1.5rem', fontFamily: 'Arial, sans-serif' }}>
        
        {/* Responsibilities Section */}
        <section style={{ marginBottom: '2.5rem', lineHeight: 1.6, fontSize: '1.1rem', textAlign: 'left' }}>
          <p>
            I worked as the sole backend developer on a team alongside two frontend developers. This role provided me with a comprehensive understanding of the entire backend tech stack and the ability to troubleshoot issues across different functional areas. My responsibilities included:
          </p>
          <ul style={{ marginLeft: '2.5rem', marginBottom: 0 }}>
            <li>Designing and setting up the database schema.</li>
            <li>Developing RESTful APIs to support application functionality.</li>
            <li>Documenting APIs for smoother frontend integration.</li>
            <li>Hosting the database and backend services on remote servers.</li>
            <li>Integrating external APIs into the system for extended functionality.</li>
            <li>Writing and executing test cases to ensure reliability and performance.</li>
            <li>Managing version control and the CI/CD pipeline using Git.</li>
          </ul>
        </section>

        {/* Developer Tools Section */}
        <section style={{ marginBottom: '2.5rem' }}>
          <h2 style={{ textAlign: 'center', fontSize: '1.3rem', color: 'var(--text-color)', marginBottom: '1.5rem' }}>Developer Tools</h2>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem', justifyContent: 'center' }}>
            {[
              'mysql', 'java', 'swagger', 'postman',
              'hibernate', 'android-studio', 'docker', 'spring-boot'
            ].map(tool => (
              <div key={tool} style={{ textAlign: 'center', width: '120px' }}>
                <img
                  src={`/static/images/${tool}.png`}
                  alt={tool.charAt(0).toUpperCase() + tool.slice(1).replace('-', ' ')}
                  style={{
                    width: '80px',
                    height: '80px',
                    objectFit: 'contain',
                    borderRadius: '12px',
                    padding: '8px',
                    marginBottom: '-8px'
                  }}
                />
                <p style={{ marginTop: '0', fontSize: '0.9rem' }}>
                  {tool.charAt(0).toUpperCase() + tool.slice(1).replace('-', ' ')}
                </p>
              </div>
            ))}
          </div>
        </section>

        
        {/* Real-time Features Section */}
        <section style={{ marginBottom: '2.5rem', lineHeight: 1.6, fontSize: '1.1rem', textAlign: 'left' }}>
        <h2 style={{ textAlign: 'center', fontSize: '1.3rem', color: 'var(--text-color)', marginBottom: '1.5rem' }}>Developer Tools</h2>
          <p>
            Websockets were used to enable real-time features within the app, including notifications and live chat functionality. Notifications keep users informed about important updates, such as reminders or newly added recipes, while the live admin chat allows users to ask questions or resolve issues promptly. This implementation ensured fast and responsive return times, enabling seamless user interactions without noticeable lag. For notifications, I implemented a WebSocket server using Java's Jakarta Websocket API, which establishes persistent connections with clients and pushes updates instantly, eliminating the need for client-side polling. The chat server, also built with the Jakarta Websocket API, mapped each session to a unique username and supported private direct messaging by specifying recipients with an @username prefix. Messages were time stamped and delivered reliably, while the server managed user connections, disconnections, and errors effectively. This setup provided a robust and efficient platform for real-time interactions, minimizing latency and ensuring responsive communication.
          </p>
        </section>

        {/* API Integrations Section */}
        <section style={{ marginBottom: '2.5rem', lineHeight: 1.6, fontSize: '1.1rem' }}>
          <div style={{ float: 'right', marginLeft: '2rem', marginBottom: '1rem', maxWidth: '225px', width: '100%' }}>
            <img
              src="/static/images/google-maps.png"
              alt="Google Maps Integration"
              style={{
                width: '100%',
                height: 'auto',
                borderRadius: '8px',
                boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
              }}
            />
          </div>
          <p>
            We integrated two open-source APIs to significantly enhance the app's functionality. The first was the Google Maps API, which provided users with detailed information about nearby grocery stores, including locations, hours of operation, and directions. Implementing this API was straightforward, thanks to its well-documented resources and its similarity to other secure APIs I've worked with before.
          </p>
          <div style={{ clear: 'both' }} />
          <div style={{ display: 'flex', justifyContent: 'center', margin: '2rem 0' }}>
            <img
              src="/static/images/pantrypal/open-food-facts-request.png"
              alt="Traffic Overview"
              style={{
                width: '100%',
                maxWidth: '750px',
                height: 'auto',
                borderRadius: '8px',
                boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
              }}
            />
          </div>
          <p>
            The second API, Open Food Facts, delivered nutritional data for various food items based on their name or barcode. This allowed users to quickly access key details such as calorie counts, ingredients, and allergen warnings. Initially, I faced a challenge with overly broad search queries like "peanut butter," which returned massive JSON responses containing over 200,000 entries. While fully resolving this issue would require refining query parameters and gaining a deeper understanding of the API's data structure, I implemented a practical workaround by averaging the attributes of all results—a solution that worked surprisingly well in practice.
          </p>
        </section>

        {/* Data Population Section */}
        <section style={{ marginBottom: '2.5rem', lineHeight: 1.6, fontSize: '1.1rem' }}>
          <h2 style={{ fontSize: '1.3rem', color: 'var(--text-color)', marginBottom: '1rem' }}>Data Population & Testing</h2>
          <p>
            For both testing and presentation purposes, the database needed to be populated with realistic data. During the development phase, I initially used Postman to verify my REST APIs and manually add data to the database. While Postman offers a "Run folder" feature to execute multiple requests sequentially, I encountered rate limits when working with the Open Food Facts API. To overcome this, I put together a simple Python script using the requests library to automate database population. This approach allowed me to implement a sleep function, adding cooldowns between requests to stay within API limits while efficiently populating the database.
          </p>
        </section>

        {/* Conclusion Section */}
        <section style={{ marginBottom: '2.5rem', lineHeight: 1.6, fontSize: '1.1rem' }}>
          <h2 style={{ fontSize: '1.3rem', color: 'var(--text-color)', marginBottom: '1rem' }}>Reflection</h2>
          <p>
            Overall, this project was a great learning experience in backend development, giving me the opportunity to design, test, and optimize backend systems from start to finish. It also enhanced my ability to work with third-party APIs, teaching me how to handle challenges like refining queries and automating data population effectively. These experiences provided me with a solid foundation for tackling real-world backend development tasks and building efficient, scalable systems.
          </p>
        </section>

        {/* Back Button Section */}
        <div style={{ textAlign: 'center', marginTop: '3rem' }}>
          <button
            onClick={() => navigate(-1)}
            className="resume-button"
            style={{
              padding: '0.75rem 2rem',
              fontSize: '1.1rem',
              cursor: 'pointer',
              textDecoration: 'none',
              border: 'none',
              background: 'var(--secondary-color)',
              color: 'var(--bg-color)',
              borderRadius: '8px',
              fontWeight: 600,
              boxShadow: '0 2px 8px var(--nav-shadow)'
            }}
          >
            Back to Home
          </button>
        </div>
      </main>

      <footer style={{
        backgroundColor: 'var(--bg-color)',
        color: 'var(--text-color)',
        padding: '1.5rem',
        textAlign: 'center',
        borderTop: '1px solid var(--accent-color)',
        marginTop: '2rem'
      }}>
        <p style={{
          fontSize: '0.9rem',
          opacity: '0.8'
        }}>
          © {new Date().getFullYear()} Robert Study. All rights reserved.
        </p>
      </footer>

      <button onClick={toggleTheme} className="theme-toggle">
        <span className="light-icon">Light Mode</span>
        <span className="dark-icon">Dark Mode</span>
      </button>
    </div>
  );
}

export default PantryPal;
